import { lazyWithRetry } from "utils";

export const ReauthReferralIntake = lazyWithRetry(() => import("./containers"));